import React from "react";
import { EvServiceInstallationData } from ".";
import ServiceOfferingSetup from "./formPages/serviceOfferingSetup";
import { createScopedSetter } from "./utility";
import ChargerConfiguration from "./formPages/chargerConfiguration";
import InstallationConfiguration from "./formPages/installationConfiguration";
import PaymentAndAssumptions from "./formPages/paymentsAndAssumptions";
import ReviewAndLaunch from "./formPages/reviewAndLaunch";
import ReviewAndUpdate from "./formPages/reviewAndUpdate";

export interface EvServiceInstallationPageItem {
  pageName: string;
  component: (
    evServiceInstallationData: EvServiceInstallationData,
    setEvServiceInstallationData: React.Dispatch<
      React.SetStateAction<EvServiceInstallationData>
    >,
  ) => JSX.Element;
}

export const EvServiceInstallationPages: EvServiceInstallationPageItem[] = [
  {
    pageName: "serviceOfferingSetup",
    component: (evServiceInstallationData, setEvServiceInstallationData) => (
      <ServiceOfferingSetup
        data={evServiceInstallationData.serviceOfferingSetup}
        setData={createScopedSetter(
          setEvServiceInstallationData,
          "serviceOfferingSetup",
        )}
      />
    ),
  },
  {
    pageName: "chargerConfig",
    component: (evServiceInstallationData, setEvServiceInstallationData) => (
      <ChargerConfiguration
        data={evServiceInstallationData.chargerConfig}
        setData={createScopedSetter(
          setEvServiceInstallationData,
          "chargerConfig",
        )}
      />
    ),
  },
  {
    pageName: "installationConfig",
    component: (evServiceInstallationData, setEvServiceInstallationData) => (
      <InstallationConfiguration
        data={evServiceInstallationData.installationConfig}
        setData={createScopedSetter(
          setEvServiceInstallationData,
          "installationConfig",
        )}
      />
    ),
  },
  {
    pageName: "paymentAndAssumptions",
    component: (evServiceInstallationData, setEvServiceInstallationData) => (
      <PaymentAndAssumptions
        data={evServiceInstallationData.paymentAndAssumptionsConfigData}
        setData={createScopedSetter(
          setEvServiceInstallationData,
          "paymentAndAssumptionsConfigData",
        )}
      />
    ),
  },
  {
    pageName: "reviewAndLaunch",
    component: (evServiceInstallationData) => (
      <ReviewAndLaunch data={evServiceInstallationData} />
    ),
  },
  {
    pageName: "reviewAndUpdate",
    component: (evServiceInstallationData) => (
      <ReviewAndUpdate data={evServiceInstallationData} />
    ),
  },
];
